import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  BrowserRouter,
} from "react-router-dom";
import Dashboard from "./Components/Dashboard/Dashboard";
import Withdrawal_Payment_Reports from "./Components/Withdrawal/Withdrawal_Payment_Reports";
import Withdrawal_Pending_List from "./Components/Withdrawal/Withdrawal_Pending_List";
import Login from "./Components/Login/Login";
import OPT_Confirm from "./Components/Login/OPT_Confirm";
import WithdrawlStart_Stop from "./Components/Member/WithdrawlStart_Stop";
import Message from "./Components/Dashboard Message/Message";
import Add_Coin from "./Components/Coin Management/Add_Coin";
import Coin_price from "./Components/Coin Management/Coin_price";
import MessageHistory from "./Components/Dashboard Message/MessageHistory";
import ProtectedRoute from "./Redux/actions/ProtectedRoute";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Buy from "./Components/Trading/Buy";
import Sell from "./Components/Trading/Sell";
import TrandingWithdrawHistory from "./Components/Member/TrandingWithdrawHistory";
import Staking_Claim_History from "./Components/Member/Staking_Claim_History";
import Edit_details from "./Components/Member/Edit_details";
import HelpDesk from "./Components/HelpDesk/HelpDesk";
import Reply from "./Components/HelpDesk/Reply";
import Commission from "./Components/HelpDesk/Commission";
import LoginHistory from "./Components/HelpDesk/LoginHistory";
// import ApprovedKyc  from "./Components/Kyc/ApprovedKyc";
// import PendingKyc from "./Components/Kyc/PendingKyc";
import Manage_subadmin from "./Components/Sub_Admin/Manage_subadmin";
import Subadmin_rights from "./Components/Sub_Admin/Subadmin_rights";
import Edit_subAdmin from "./Components/Sub_Admin/Edit_subAdmin";
import Add_subAdmin from "./Components/Sub_Admin/Add_subAdmin";
import My_Team from "./Components/Team_Reports/My team";
import Contact from "./Components/Contact/Contact";
import Add_HomePageCoin from "./Components/HomePageCoin/Add_HomePageCoin";
import HomePageCoinDetails from "./Components/HomePageCoin/HomePageCoinDetails";
import Update_HomePageCoin from "./Components/HomePageCoin/Update_HomePageCoin";
import RequestToken from "./Components/Request Token/RequestToken";
import RequestTokenUpdate from "./Components/Request Token/RequestTokenUpdate";
import RequestTokenPaid from "./Components/Request Token/RequestTokenPaid";
import RequestTokenCancel from "./Components/Request Token/RequestTokenCancel";
import Active_Member from "./Components/Member/ACTIVE_MEMBER_LIST";
import Level_detail from "./Components/Team_Reports/Level_detail";
import Direct_team from "./Components/Team_Reports/Direct_team";
import ActivationByAdmin from "./Components/Activation/ActivationByAdmin";
import RetopupHistory from "./Components/Member/RetopupHistory";
import All_member from "./Components/Member/All_member";
import UpgradeID from "./Components/Activation/UpgradeID";
import ActivationUHistory from "./Components/Activation/ActivationUHistory";
import DirectLegBusiness from "./Components/Team_Reports/DirectLegBusiness";
import AddPowerleg from "./Components/Power Leg/AddPowerleg";
import PowerlegHis from "./Components/Power Leg/PowerlegHis";
import RoiRate from "./Components/Power Leg/RoiRate";
import LevelIncome from "./Components/Income Reports/LevelIncome";
import TeamReward_income from "./Components/Income Reports/TeamReward_income";
import Total_incomeReport from "./Components/Income Reports/Total_incomeReport";
import RoiIncome from "./Components/Income Reports/RoiIncome";
import ClosedHelpDesk from "./Components/HelpDesk/ClosedHelpDesk";
import SubadminHistory from "./Components/Sub_Admin/SubadminHistory";
import InvestmentSummary from "./Components/Member/InvestmentSummary";
import Member_Details from "./Components/Member/Member_Details";
import MonthlyBonusReward from "./Components/Income Reports/MonthlyBonusReward";
import ActivationByAdminStake from "./Components/Activation/ActivationByAdminStake";
import ActivationUHistoryStake from "./Components/Activation/ActivationUHistoryStake";
import MonthlyBonusRewardPaid from "./Components/Income Reports/MonthlyBonusRewardPaid";
import TeamReward_incomepaid from "./Components/Income Reports/TeamReward_incomepaid";
import Upgrade_MEMBER_LIST from "./Components/Member/Upgrade_MEMBER_LIST";
import WithdrawalInvestment from "./Components/Income Reports/WithdrawalInvestment";
import LevelIncomePlanB from "./Components/Income Reports/LevelIncomePlanB";
import RoiIncomePlanB from "./Components/Income Reports/RoiIncomePlanB";
import ActivationByAdminPlanB from "./Components/Activation/ActivationByAdminPlanB";
import ActivationUHistoryPlanB from "./Components/Activation/ActivationUHistoryPlanB";
import ActivationUStakePaid from "./Components/Activation/ActivationUStakePaid";
import ActivationUStakePending from "./Components/Activation/ActivationUStakePending";
import UsdtBonusDetails from "./Components/QR Details/UsdtBonusDetails";
import PendingUsdtRequest from "./Components/QR Details/PendingUsdtRequest";
import UsdtContractHistory from "./Components/QR Details/UsdtContractHistory";
import ActivationByAdminStakePlanB from "./Components/Activation/ActivationByAdminStakePlanB";
import ActivationUHistoryStakePlanB from "./Components/Activation/ActivationUHistoryStakePlanB";
import ActivationUStakePlanBPaid from "./Components/Activation/ActivationUStakePlanBPaid";
import ActivationUStakePlanBPending from "./Components/Activation/ActivationUStakePlanBPending";
import Stakeincome from "./Components/Income Reports/Stakeincome";
import TradingRevenueBonus from "./Components/Income Reports/TradingRevenueBonus";
import OneTimeProfitBonus from "./Components/Income Reports/OneTimeProfitBonus";
import OLDROIIncome from "./Components/Income Reports/OLDROIIncome";
import IntroductionBonus from "./Components/Income Reports/IntroductionBonus";
import ActivationInterface from "./Components/Activation/ActivationInterface";
import UpgradeByAdmin from "./Components/Activation/UpgradeByAdmin";
import ActOneTimeProfitInterface from "./Components/Activation/ActOneTimeProfitInterface";
import UpgradeActOneTimeProfit from "./Components/Activation/UpgradeActOneTimeProfit";
import ActivationStakeInterface from "./Components/Activation/ActivationStakeInterface";
import UpgradeByAdminStake from "./Components/Activation/UpgradeByAdminStake";
import ActivationUHistory_User from "./Components/Activation/ActivationUHistory_User";
import ActivationUHistoryPlanB_User from "./Components/Activation/ActivationUHistoryPlanB_User";
import ActivationUHistoryStake_User from "./Components/Activation/ActivationUHistoryStake_User";
import ActionHistoryOld_User from "./Components/Activation/ActionHistoryOld_User";
import BankWithdrawal_Pending_List from "./Components/Withdrawal/BankWithdrawal_Pending_List";
import ZeroPinActivation from "./Components/Activation/ZeroPinActivation";
import ZeroPinActivationHistory from "./Components/Activation/ZeroPinActivationHistory";
import BulkWithdrawal from "./Components/Withdrawal/BulkWithdrawal";
import User_bankDetails from "./Components/Income Reports/User_bankDetails";
import Websitepopup from "./Components/QR Details/Websitepopup";
import StopIncome from "./Components/Member/StopIncome";
import UserAllIncomeDetails from "./Components/Income Reports/UserAllIncomeDetails";
import CapitalBalance from "./Components/Income Reports/CapitalBalance";
import CompletedIntroductionBonus from "./Components/Team_Reports/CompletedIntroductionBonus";
import MonthWisePayout from "./Components/Income Reports/MonthWisePayout";
import UPIQRDetails from "./Components/QR Details/UPIQRDetails";
import AdminBankDetails from "./Components/QR Details/AdminBankDetails";
import Trc20QRDetails from "./Components/QR Details/Trc20QRDetails";

function App() {
  // useEffect(() => {
  //   const handleContextMenu = (event) => {
  //     event.preventDefault();
  //   };

  //   document.addEventListener("contextmenu", handleContextMenu);

  //   document.addEventListener("keydown", (e) => {
  //     if (
  //       (e.ctrlKey &&
  //         (e.key === "I" ||
  //           e.key === "i" ||
  //           e.key === "u" ||
  //           e.key === "U" ||
  //           e.key === "J" ||
  //           e.key === "j" ||
  //           e.key === "C" ||
  //           e.key === "c")) ||
  //       e.key === "F12"
  //     ) {
  //       e.preventDefault();
  //     }
  //   });

  //   return () => {
  //     document.removeEventListener("contextmenu", handleContextMenu);
  //   };
  // }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <ToastContainer />
        <Routes>
          <Route />
          <Route exact path="/" element={<Login />} />
          <Route exact path="/OPT_Confirm" element={<OPT_Confirm />} />
          <Route
            exact
            path="/Dashboard"
            element={<ProtectedRoute component={Dashboard} />}
          />
          <Route
            exact
            path="/Allmember"
            element={<ProtectedRoute component={All_member} />}
          />
          <Route
            exact
            path="/Dashboard_Message"
            element={<ProtectedRoute component={Message} />}
          />
          <Route
            exact
            path="/MessageHistory"
            element={<ProtectedRoute component={MessageHistory} />}
          />

          <Route
            exact
            path="/Member_Details"
            element={<ProtectedRoute component={Member_Details} />}
          />
          <Route
            exact
            path="/StopIncome"
            element={<ProtectedRoute component={StopIncome} />}
          />
          <Route
            exact
            path="/WithdrawlStart_Stop"
            element={<ProtectedRoute component={WithdrawlStart_Stop} />}
          />
          <Route
            exact
            path="/ActiveMember"
            element={<ProtectedRoute component={Active_Member} />}
          />
          <Route
            exact
            path="/upgradeMember"
            element={<ProtectedRoute component={Upgrade_MEMBER_LIST} />}
          />
          <Route
            exact
            path="/BusinessSummary"
            element={<ProtectedRoute component={InvestmentSummary} />}
          />

          <Route
            exact
            path="/RetopupHistory"
            element={<ProtectedRoute component={RetopupHistory} />}
          />
          <Route
            exact
            path="/ActivationPlanB"
            element={<ProtectedRoute component={ActivationByAdminPlanB} />}
          />
          <Route
            exact
            path="/ActOneTimeProfitInterface"
            element={<ProtectedRoute component={ActOneTimeProfitInterface} />}
          />
          <Route
            exact
            path="/UpgradeActOneTimeProfit"
            element={<ProtectedRoute component={UpgradeActOneTimeProfit} />}
          />
          <Route
            exact
            path="/ActivationhistoryPlanB"
            element={<ProtectedRoute component={ActivationUHistoryPlanB} />}
          />
          <Route
            exact
            path="/ActivationUHistoryPlanB_User"
            element={
              <ProtectedRoute component={ActivationUHistoryPlanB_User} />
            }
          />
          <Route
            exact
            path="/Activation"
            element={<ProtectedRoute component={ActivationByAdmin} />}
          />
          <Route
            exact
            path="/ZeroPinActivation"
            element={<ProtectedRoute component={ZeroPinActivation} />}
          />
          <Route
            exact
            path="/ZeroPinActivationHistory"
            element={<ProtectedRoute component={ZeroPinActivationHistory} />}
          />
          <Route
            exact
            path="/Activationhistory"
            element={<ProtectedRoute component={ActivationUHistory} />}
          />
          <Route
            exact
            path="/ActivationUHistory_User"
            element={<ProtectedRoute component={ActivationUHistory_User} />}
          />
          <Route
            exact
            path="/ActivationUHistoryStake"
            element={<ProtectedRoute component={ActivationUHistoryStake} />}
          />
          <Route
            exact
            path="/ActivationUHistoryStake_User"
            element={
              <ProtectedRoute component={ActivationUHistoryStake_User} />
            }
          />
          <Route
            exact
            path="/ActionHistoryOld_User"
            element={<ProtectedRoute component={ActionHistoryOld_User} />}
          />
          <Route
            exact
            path="/ActivationByAdminStake"
            element={<ProtectedRoute component={ActivationByAdminStake} />}
          />
          <Route
            exact
            path="/UpgradeByAdminStake"
            element={<ProtectedRoute component={UpgradeByAdminStake} />}
          />
          <Route
            exact
            path="/ActivationStakeInterface"
            element={<ProtectedRoute component={ActivationStakeInterface} />}
          />
          <Route
            exact
            path="/ActivationUHistoryStakePlanB"
            element={
              <ProtectedRoute component={ActivationUHistoryStakePlanB} />
            }
          />
          <Route
            exact
            path="/ActivationByAdminStakePlanB"
            element={<ProtectedRoute component={ActivationByAdminStakePlanB} />}
          />
          <Route
            exact
            path="/ActivationUStakePaid"
            element={<ProtectedRoute component={ActivationUStakePaid} />}
          />
          <Route
            exact
            path="/ActivationUStakePending"
            element={<ProtectedRoute component={ActivationUStakePending} />}
          />
          <Route
            exact
            path="/ActivationUStakePaidPlanB"
            element={<ProtectedRoute component={ActivationUStakePlanBPaid} />}
          />
          <Route
            exact
            path="/ActivationUStakePendingPlanB"
            element={
              <ProtectedRoute component={ActivationUStakePlanBPending} />
            }
          />
          <Route
            exact
            path="/UpgradeByAdmin"
            element={<ProtectedRoute component={UpgradeByAdmin} />}
          />

          <Route
            exact
            path="/roirate"
            element={<ProtectedRoute component={RoiRate} />}
          />
          <Route
            exact
            path="/addpower"
            element={<ProtectedRoute component={AddPowerleg} />}
          />

          <Route
            exact
            path="/powerhistory"
            element={<ProtectedRoute component={PowerlegHis} />}
          />

          <Route
            exact
            path="/Withdrawal_History"
            element={<ProtectedRoute component={Withdrawal_Payment_Reports} />}
          />

          <Route
            exact
            path="/BulkWithdrawal"
            element={<ProtectedRoute component={BulkWithdrawal} />}
          />
          <Route
            exact
            path="/Websitepopup"
            element={<ProtectedRoute component={Websitepopup} />}
          />
          <Route
            exact
            path="/Pending_Withdrawal"
            element={<ProtectedRoute component={Withdrawal_Pending_List} />}
          />
          <Route
            exact
            path="/bankPending_Withdrawal"
            element={<ProtectedRoute component={BankWithdrawal_Pending_List} />}
          />
          <Route
            exact
            path="/Add_Coin"
            element={<ProtectedRoute component={Add_Coin} />}
          />
          <Route
            exact
            path="/Coin_Base_Price"
            element={<ProtectedRoute component={Coin_price} />}
          />
          <Route
            exact
            path="/Buy"
            element={<ProtectedRoute component={Buy} />}
          />
          <Route
            exact
            path="/Sell"
            element={<ProtectedRoute component={Sell} />}
          />
          <Route
            exact
            path="/DepositeHistory"
            element={<ProtectedRoute component={Staking_Claim_History} />}
          />

          <Route
            exact
            path="/Cancel_Withdrawal"
            element={<ProtectedRoute component={TrandingWithdrawHistory} />}
          />
          <Route
            exact
            path="/Edit_Details"
            element={<ProtectedRoute component={Edit_details} />}
          />
          <Route
            exact
            path="/HelpDesk"
            element={<ProtectedRoute component={HelpDesk} />}
          />
          <Route
            exact
            path="/ClosedHelpDesk"
            element={<ProtectedRoute component={ClosedHelpDesk} />}
          />
          <Route
            exact
            path="/Reply"
            element={<ProtectedRoute component={Reply} />}
          />
          <Route
            exact
            path="/PendingReward"
            element={<ProtectedRoute component={RequestToken} />}
          />
          <Route
            exact
            path="/PaidRewardHistory"
            element={<ProtectedRoute component={RequestTokenPaid} />}
          />
          <Route
            exact
            path="/RequestTokenUpdate"
            element={<ProtectedRoute component={RequestTokenUpdate} />}
          />
          <Route
            exact
            path="/Commission_Report"
            element={<ProtectedRoute component={Commission} />}
          />
          <Route
            exact
            path="/LoginHistory"
            element={<ProtectedRoute component={LoginHistory} />}
          />
          {/* <Route exact path="/ApprovedKyc" element={<ProtectedRoute component={ApprovedKyc}/>} />
        <Route exact path="/PendingKyc" element={<ProtectedRoute component={PendingKyc}/>} /> */}
          <Route
            exact
            path="/Manage_subadmin"
            element={<ProtectedRoute component={Manage_subadmin} />}
          />
          <Route
            exact
            path="/Subadmin_rights"
            element={<ProtectedRoute component={Subadmin_rights} />}
          />
          <Route
            exact
            path="/Edit_SubAdmin"
            element={<ProtectedRoute component={Edit_subAdmin} />}
          />
          <Route
            exact
            path="/Add_SubAdmin"
            element={<ProtectedRoute component={Add_subAdmin} />}
          />

          <Route
            exact
            path="/LevelIncome"
            element={<ProtectedRoute component={LevelIncome} />}
          />
          <Route
            exact
            path="/RoiIncome"
            element={<ProtectedRoute component={RoiIncome} />}
          />

          <Route
            exact
            path="/LevelIncomePlanB"
            element={<ProtectedRoute component={LevelIncomePlanB} />}
          />

          <Route
            exact
            path="/RoiIncomePlanB"
            element={<ProtectedRoute component={RoiIncomePlanB} />}
          />
          <Route
            exact
            path="/Stakeincome"
            element={<ProtectedRoute component={Stakeincome} />}
          />
          <Route
            exact
            path="/WithdrawalInvestment"
            element={<ProtectedRoute component={WithdrawalInvestment} />}
          />

          <Route
            exact
            path="/TeamReward_income"
            element={<ProtectedRoute component={TeamReward_income} />}
          />
          <Route
            exact
            path="/TeamReward_incomepaid"
            element={<ProtectedRoute component={TeamReward_incomepaid} />}
          />
          <Route
            exact
            path="/MonthlyBonusReward"
            element={<ProtectedRoute component={MonthlyBonusReward} />}
          />
          <Route
            exact
            path="/MonthlyBonusRewardPaid"
            element={<ProtectedRoute component={MonthlyBonusRewardPaid} />}
          />

          <Route
            exact
            path="/Total_incomeReport"
            element={<ProtectedRoute component={Total_incomeReport} />}
          />
          <Route
            exact
            path="/TradingRevenueBonus"
            element={<ProtectedRoute component={TradingRevenueBonus} />}
          />
          <Route
            exact
            path="/OneTimeProfitBonus"
            element={<ProtectedRoute component={OneTimeProfitBonus} />}
          />
          <Route
            exact
            path="/OLDROIIncome"
            element={<ProtectedRoute component={OLDROIIncome} />}
          />
          <Route
            exact
            path="/CapitalBalance"
            element={<ProtectedRoute component={CapitalBalance} />}
          />
          <Route
            exact
            path="/IntroductionBonus"
            element={<ProtectedRoute component={IntroductionBonus} />}
          />
          <Route
            exact
            path="/User_bankDetails"
            element={<ProtectedRoute component={User_bankDetails} />}
          />

          {/* <Route exact path="/Add_MarketCoin" element={<ProtectedRoute component={Add_MarketCoin}/>} /> 
        <Route exact path="/MarketCoinHistory" element={<ProtectedRoute component={MarketCoinHistory}/>} /> 
        <Route exact path="/Update_Coin_Details" element={<ProtectedRoute component={UpdateCoin}/>}/> */}
          <Route
            exact
            path="/My_Team"
            element={<ProtectedRoute component={My_Team} />}
          />

          <Route
            exact
            path="/myreferrals"
            element={<ProtectedRoute component={Direct_team} />}
          />
          <Route
            exact
            path="/CompletedIntroductionBonus"
            element={<ProtectedRoute component={CompletedIntroductionBonus} />}
          />
          <Route
            exact
            path="/Level_detail"
            element={<ProtectedRoute component={Level_detail} />}
          />
          <Route
            exact
            path="/DirectLegBusiness"
            element={<ProtectedRoute component={DirectLegBusiness} />}
          />

          <Route
            exact
            path="/levelDetails"
            element={<ProtectedRoute component={Level_detail} />}
          />
          <Route
            exact
            path="/Contact_Query"
            element={<ProtectedRoute component={Contact} />}
          />
          <Route
            exact
            path="/Add_HomePageCoin"
            element={<ProtectedRoute component={Add_HomePageCoin} />}
          />
          <Route
            exact
            path="/HomePageCoinDetails"
            element={<ProtectedRoute component={HomePageCoinDetails} />}
          />
          <Route
            exact
            path="/Update_HomePageCoin"
            element={<ProtectedRoute component={Update_HomePageCoin} />}
          />
          <Route
            exact
            path="/RequestTokenCancel"
            element={<ProtectedRoute component={RequestTokenCancel} />}
          />

          <Route
            exact
            path="/UsdtqrDetails"
            element={<ProtectedRoute component={UsdtBonusDetails} />}
          />
          <Route
            exact
            path="/Trc20QRDetails"
            element={<ProtectedRoute component={Trc20QRDetails} />}
          />
          <Route
            exact
            path="/UPIQRDetails"
            element={<ProtectedRoute component={UPIQRDetails} />}
          />
          <Route
            exact
            path="/AdminBankDetails"
            element={<ProtectedRoute component={AdminBankDetails} />}
          />
          <Route
            exact
            path="/PendingQRRequest"
            element={<ProtectedRoute component={PendingUsdtRequest} />}
          />
          <Route
            exact
            path="/qrHistory"
            element={<ProtectedRoute component={UsdtContractHistory} />}
          />
          <Route
            exact
            path="/SubadminHistory"
            element={<ProtectedRoute component={SubadminHistory} />}
          />
          <Route
            exact
            path="/ActivationInterface"
            element={<ProtectedRoute component={ActivationInterface} />}
          />
          <Route
            exact
            path="/UserAllIncomeDetails"
            element={<ProtectedRoute component={UserAllIncomeDetails} />}
          />
          <Route
            exact
            path="/MonthWisePayout"
            element={<ProtectedRoute component={MonthWisePayout} />}
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
